<template>
  <div>
    <h3>任务申诉管理</h3>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="complainId" label="申诉单号"></el-table-column>
      <el-table-column prop="contractId" label="订单编号"></el-table-column>
      <el-table-column prop="partyAName" label="申诉人"></el-table-column>
      <el-table-column prop="partyBName" label="被申诉人"></el-table-column>
      <el-table-column prop="complainStatus" label="申诉状态">
        <template slot-scope="scope">{{
          map.appeal.status[scope.row.complainStatus]
        }}</template>
      </el-table-column>
      <el-table-column prop="acceptStatus" label="被申诉人认可状态">
        <template slot-scope="scope">{{
          map.appeal.agreeStatus[scope.row.acceptStatus]
        }}</template>
      </el-table-column>
      <el-table-column prop="complainTime" label="申诉时间"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间"></el-table-column>
      <el-table-column
        prop="complainContent"
        label="申诉详情"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command=""
                ><a
                  :href="`/appeal/detail/${scope.row.complainId}`"
                  target="_blank"
                  >查看详情</a
                ></el-dropdown-item
              >
              <el-dropdown-item
                :disabled="scope.row.complainStatus > 1"
                :command="{ action: 'accept', data: scope.row }"
                >受理申诉</el-dropdown-item
              >
              <el-dropdown-item
                :disabled="scope.row.complainStatus > 1"
                :command="{ action: 'reject', data: scope.row }"
                >驳回申诉</el-dropdown-item
              >
              <el-dropdown-item
                :disabled="scope.row.complainStatus !== 4"
                :command="{ action: 'finish', data: scope.row }"
                >结束申诉单</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog title="是否确认受理该申诉单？" :visible.sync="dialog.accept">
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="update('accept')">确 认</el-button>
        <el-button @click="toggleDialog('accept')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="是否确认驳回该申诉单？" :visible.sync="dialog.reject">
      <el-form :model="reject" ref="reject">
        <el-form-item
          prop="option"
          :rules="[
            {
              required: true,
              message: '请填写驳回理由',
            },
          ]"
        >
          <el-input
            type="textarea"
            placeholder="请填写驳回理由"
            :rows="3"
            v-model.trim="reject.option"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('reject')">确 认</el-button>
        <el-button @click="toggleDialog('reject')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="是否确认结束该申诉单？" :visible.sync="dialog.finish">
      <el-form :model="finish" ref="finish">
        <el-form-item
          prop="platformResults"
          :rules="[
            {
              required: true,
              message: '选择平台处理结果',
            },
          ]"
        >
          <el-select
            v-model="finish.platformResults"
            placeholder="选择平台处理结果"
          >
            <el-option
              v-for="(label, value) in map.appeal.result"
              :key="value"
              :label="label"
              :value="value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="option"
          :rules="[
            {
              required: true,
              message: '填写平台处理意见',
            },
          ]"
        >
          <el-input
            type="textarea"
            placeholder="填写平台处理意见"
            :rows="3"
            v-model.trim="finish.option"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('finish')">确 认</el-button>
        <el-button @click="toggleDialog('finish')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";

const { appeal } = api;

export default {
  name: "taskAppeals",
  data() {
    return {
      map,
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      total: 0,
      isSubmiting: false,
      dialog: {
        accept: false,
        reject: false,
        finish: false,
      },
      curData: {},
      reject: {
        option: "",
      },
      finish: {
        option: "",
        platformResults: "",
      },
    };
  },
  components: {},
  computed: {},
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  created() {},
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;
      let obj = {
        pageNum: pageNum,
        limit: limit,
        type: 1, // 任务申诉类型
      };

      let res = await appeal.list(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    toggleDialog(name, data) {
      console.log(data);
      if (data) {
        this.curData = data;
      } else {
        this.curData = {};
        this.reject = {
          option: "",
        };
        this.finish = {
          option: "",
          platformResults: "",
        };
      }
      this.dialog[name] = !this.dialog[name];
      console.log(this.dialog[name]);
    },
    handleCommand(command) {
      let action = command.action;
      let data = command.data;
      this.toggleDialog(action, data);
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.update(formName);
        } else {
          return false;
        }
      });
    },
    async update(action) {
      let status = 4;
      let obj = {
        complainId: this.curData.complainId,
      };
      switch (action) {
        case "accept":
          status = 4;
          break;
        case "reject":
          status = 2;
          obj.option = this.reject.option;
          break;
        case "finish":
          status = 6;
          obj.option = this.finish.option;
          obj.platformResults = this.finish.platformResults;
          break;
        default:
      }
      obj.complainStatus = status;
      let res = await appeal.updateStatus(obj);
      this.fetch();
      this.toggleDialog(action);
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/taskManage/taskAppeals.vue